import React from "react";
import {
  callAuthCalcPostDate,
  callAuthSubmitAchPayment,
  callAuthCheckPayoff,
} from "../../../actions/authPayment.actions";
import { connect } from "react-redux";
import { AuthPaymentExternalAch } from "../payment-forms/auth-payment-external-ach.component";
import { AuthExternalAchReview } from "../review/auth-bank-review-fields.component";
import { AuthPaymentExternalAchSummary } from "../summary/auth-payment-external-ach-summary.component";
import { usd, removeSpecialCharacters } from "../../../utils/utils";
import moment from "moment";

const StandardExternalAchFlowComponent = (props) => {
  const currentForm = props.form["AuthPaymentExternalAch"];
  const paymentResponse = props.authPayment.paymentResponse;
  const payoffCheckResponse = props.authPayment.payoffCheck;
  const amountPastDueBetweenPayoffAndBalance = props.amountPastDueBetweenPayoffAndBalance;

  const isPrincipalOnly = props.paymentInfo.isPrincipalOnly;
  const hasSelectedPayoff = props.paymentInfo.hasSelectedPayoff;

  const omitScheduledPaymentDateFromReview =
    amountPastDueBetweenPayoffAndBalance ||
    hasSelectedPayoff ||
    payoffCheckResponse.PaymentTypeChangedToPayoff;

  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  switch (processStep) {
    case 1:
      return (
        <AuthPaymentExternalAch
          {...props.authPayment.selectedLoanAdditionalDetails}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          authPayment={props.authPayment}
          achPostDate={props.authPayment.achPostDate}
          thisForm={currentForm}
          achInstitution={props.achInstitution}
          callAuthCheckPayoff={props.callAuthCheckPayoff}
          callAuthCalcPostDate={props.callAuthCalcPostDate}
          isPrincipalOnly={isPrincipalOnly}
          hasSelectedPayoff={hasSelectedPayoff}
          backToLoans={backToLoans}
          amountPastDueBetweenPayoffAndBalance={amountPastDueBetweenPayoffAndBalance}
        />
      );
    case 2:
      return (
        <AuthExternalAchReview
          scheduledPaymentDate={
            omitScheduledPaymentDateFromReview ? null : currentForm.values.ScheduledPaymentDate
          }
          paymentAppliedDate={moment(props.authPayment.achPostDate).format("MM/DD/YYYY")}
          paymentAccount={currentForm.values.AccountNumber.slice(-4)}
          paymentAmount={usd.format(removeSpecialCharacters(currentForm.values.Amount))}
          externalAchFormValues={currentForm.values}
          selectedLoan={selectedLoan}
          setProcessStep={setProcessStep}
          paymentResponse={paymentResponse}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          callAuthSubmitAchPayment={props.callAuthSubmitAchPayment}
          backToLoans={backToLoans}
        />
      );
    case 3:
      return (
        <AuthPaymentExternalAchSummary
          scheduledPaymentDate={
            omitScheduledPaymentDateFromReview && paymentResponse.PaymentDate
              ? null
              : moment(paymentResponse.PaymentDate).format("MM/DD/YYYY")
          }
          paymentAppliedDate={moment(paymentResponse.PostDate).format("MM/DD/YYYY")}
          paymentAccount={paymentResponse.CardNumberLastFour}
          paymentAmount={usd.format(paymentResponse.PaymentAmount)}
          isPayoff={payoffCheckResponse.PaymentTypeChangedToPayoff}
          confirmationEmail={paymentResponse.EmailAddress}
          selectedLoan={selectedLoan}
          isPrincipalOnly={isPrincipalOnly}
          backToLoans={backToLoans}
        />
      );
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthCalcPostDate,
  callAuthSubmitAchPayment,
  callAuthCheckPayoff,
};

const StandardExternalAchFlow = connect(null, mapDispatchToProps)(StandardExternalAchFlowComponent);

export default StandardExternalAchFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/standard-external-ach-flow.component.js